import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

import SEO from '../components/SEO';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        path="/404"
        noindex
        titleOverride={`${t('notFound.title')} — takuna stay`}
      />
      <main
        id="main"
        className="flex min-h-screen flex-col items-center justify-center bg-bg px-6 text-center text-ink"
      >
        <div className="mb-4 font-mono text-xs uppercase tracking-[0.2em] text-accent">№&nbsp;&nbsp;404</div>
        <h1 className="m-0 max-w-[640px] text-balance font-display font-semibold leading-tight tracking-display [font-size:clamp(48px,7vw,96px)]">
          {t('notFound.headline')}
        </h1>
        <p className="mt-6 max-w-[480px] text-[17px] leading-relaxed text-muted">{t('notFound.copy')}</p>
        <Link
          to="/"
          className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-accent px-7 py-4 text-[15px] font-medium text-white no-underline transition hover:brightness-105"
        >
          {t('notFound.cta')} <span aria-hidden>→</span>
        </Link>
      </main>
    </>
  );
}
